export var LifecyclesVoData;
(function (LifecyclesVoData) {
    LifecyclesVoData["TASK_TYPE_1_LCS"] = "TASK_TYPE_1_LCS";
    LifecyclesVoData["TASK_TYPE_2_LCS"] = "TASK_TYPE_2_LCS";
    LifecyclesVoData["TASK_TYPE_3_LCS"] = "TASK_TYPE_3_LCS";
    LifecyclesVoData["TASK_TYPE_4_LCS"] = "TASK_TYPE_4_LCS";
    LifecyclesVoData["TASK_TYPE_5_LCS"] = "TASK_TYPE_5_LCS";
    LifecyclesVoData["TASK_TYPE_6_LCS"] = "TASK_TYPE_6_LCS";
    LifecyclesVoData["TASK_TYPE_7_LCS"] = "TASK_TYPE_7_LCS";
    LifecyclesVoData["TASK_TYPE_8_LCS"] = "TASK_TYPE_8_LCS";
    LifecyclesVoData["TASK_TYPE_9_LCS"] = "TASK_TYPE_9_LCS";
    LifecyclesVoData["TASK_TYPE_10_LCS"] = "TASK_TYPE_10_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_1_LCS"] = "REQUIREMENT_TYPE_1_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_2_LCS"] = "REQUIREMENT_TYPE_2_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_3_LCS"] = "REQUIREMENT_TYPE_3_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_4_LCS"] = "REQUIREMENT_TYPE_4_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_5_LCS"] = "REQUIREMENT_TYPE_5_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_6_LCS"] = "REQUIREMENT_TYPE_6_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_7_LCS"] = "REQUIREMENT_TYPE_7_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_8_LCS"] = "REQUIREMENT_TYPE_8_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_9_LCS"] = "REQUIREMENT_TYPE_9_LCS";
    LifecyclesVoData["REQUIREMENT_TYPE_10_LCS"] = "REQUIREMENT_TYPE_10_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_1_LCS"] = "FEEDBACK_TYPE_1_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_2_LCS"] = "FEEDBACK_TYPE_2_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_3_LCS"] = "FEEDBACK_TYPE_3_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_4_LCS"] = "FEEDBACK_TYPE_4_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_5_LCS"] = "FEEDBACK_TYPE_5_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_6_LCS"] = "FEEDBACK_TYPE_6_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_7_LCS"] = "FEEDBACK_TYPE_7_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_8_LCS"] = "FEEDBACK_TYPE_8_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_9_LCS"] = "FEEDBACK_TYPE_9_LCS";
    LifecyclesVoData["FEEDBACK_TYPE_10_LCS"] = "FEEDBACK_TYPE_10_LCS";
    LifecyclesVoData["FOLDER_TYPE_LCS"] = "FOLDER_TYPE_LCS";
    LifecyclesVoData["SPACE_TYPE_0_LCS"] = "SPACE_TYPE_0_LCS";
    LifecyclesVoData["SPACE_TYPE_1_LCS"] = "SPACE_TYPE_1_LCS";
    LifecyclesVoData["SPACE_TYPE_2_LCS"] = "SPACE_TYPE_2_LCS";
    LifecyclesVoData["SPACE_TYPE_3_LCS"] = "SPACE_TYPE_3_LCS";
    LifecyclesVoData["SPACE_TYPE_4_LCS"] = "SPACE_TYPE_4_LCS";
    LifecyclesVoData["SPACE_TYPE_5_LCS"] = "SPACE_TYPE_5_LCS";
    LifecyclesVoData["SPACE_TYPE_6_LCS"] = "SPACE_TYPE_6_LCS";
    LifecyclesVoData["SPACE_TYPE_7_LCS"] = "SPACE_TYPE_7_LCS";
    LifecyclesVoData["SPACE_TYPE_8_LCS"] = "SPACE_TYPE_8_LCS";
    LifecyclesVoData["SPACE_TYPE_9_LCS"] = "SPACE_TYPE_9_LCS";
})(LifecyclesVoData || (LifecyclesVoData = {}));
//# sourceMappingURL=lifecycles-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/lifecycle-status/lifecycles-vo-data.js
// module id = 946
// module chunks = 14